<template>
  <div class="col-12">
    <b-card>
      <div slot="header">
        <strong v-text="$lang.edit_question_suggest"></strong>
        <div v-if="item" class="float-right">
          {{ $lang.number_question }} : {{ pathOr("", ["id"], item) }}
        </div>
      </div>

      <div v-if="isLoading" class="text-center">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <interviewForm
        mode="edit"
        v-if="!isLoading && item"
        :permissions="permissions"
        :item="item"
        @cancel="handleBack"
        @submit="save"
      />
    </b-card>
  </div>
</template>

<script>
import {
  generateCurrentRoute,
  generateError,
  goToRoute,
  toastAlert,
} from "@/shared/utils";
import interviewForm from "./../forms/interviewForm";
import {
  getMyQuestionSuggest,
  updateMyQuestionSuggest,
} from "@/modules/interview/services";
import { pathOr } from "ramda";
export default {
  components: {
    interviewForm,
  },
  inject: ["questionSuggestRepository", "questionSuggestEvaluationRepository"],
  data() {
    return {
      id: this.$route.params.id,
      item: null,
      isLoading: false,
      permissions: [],
      openText: false,
    };
  },
  methods: {
    pathOr,
    handleBack() {
      const centerExecuteListBackRoute = localStorage.getItem(
        "questionSuggestBackRoute"
      );
      goToRoute(centerExecuteListBackRoute, {}, {}, false);
    },
    async fetchData() {
      try {
        this.isLoading = true;
        const currentRoteName = generateCurrentRoute();

        const response =
          currentRoteName === "edit-my-question-suggest"
            ? await getMyQuestionSuggest(this.id)
            : await this.questionSuggestRepository.find(this.id);

        this.item = pathOr(null, ["data", "data"], response);
        this.permissions = pathOr([], ["data", "permissions"], response);
      } catch (error) {
        generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async save(payload) {
      try {
        this.isLoading = true;
        const currentRoteName = generateCurrentRoute();
        const response =
          currentRoteName === "edit-my-question-suggest"
            ? await updateMyQuestionSuggest(this.id, payload)
            : await this.questionSuggestRepository.edit(this.id, payload);

        const { message } = response;
        toastAlert(message);
        this.handleBack();
      } catch (error) {
        generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
